import { SagaIterator } from 'redux-saga';
import { FetchDutyStatusPayload, ChangeDutyStatusPayload, DutyStatus } from 'src/common/types';
import apiClient from '../common/apiClient';
import moment from 'moment';

export function fetchDutyStatusApi(payload: FetchDutyStatusPayload): SagaIterator<DutyStatus> {
  const timestamp = moment()
    .utc()
    .toISOString();
  return apiClient.get(`/eld/drivers/${payload.userId}/duty_status?timestamp=${timestamp}`, {});
}

export function changeDutyStatusApi(payload: ChangeDutyStatusPayload): SagaIterator {
  const { employeeId, ...rest } = payload;
  return apiClient.post(`/eld/drivers/${employeeId}/duty_status`, rest);
}
